export default __webpack_public_path__ + "static/_49A4094.png";